import { createStyles } from '@mantine/core'

export default createStyles((theme, { color }: { color?: string }) => {
  return {
    arrow: {
      ...(color && {
        border: `1px solid ${color}`,
        '&:hover': {
          backgroundColor: theme.fn.lighten(color, 0.9),
        },
      }),
    },
    arrowIcon: {
      ...(color && {
        color,
      }),
    },
  }
})
